export const MESSAGES_PER_REQUEST = 20;
